import { Component } from '@theme/component';

/**
 * @typedef {object} LocalizationRefs
 * @property {HTMLSelectElement} [country]
 * @property {HTMLSelectElement | HTMLInputElement} language
 * @property {HTMLTemplateElement} languages
 * @property {HTMLSpanElement} status
 * @extends {Component<LocalizationRefs>}
 */
class KunnieLocalization extends Component {
  focusSearchInput = () => {
    (this.refs.country || this.refs.language)?.focus();
  };

  resetForm() {
    if (this.refs.status) this.refs.status.textContent = '';
  }

  changeCountry() {
    const { country, language, languages, status } = this.refs;
    if (!country || !language || !languages) return;

    const codes = (country.selectedOptions[0]?.dataset.languages || '').split(',').filter(Boolean);
    const previous = language.value;
    const options = codes.flatMap((code) => {
      const source = Array.from(languages.content.querySelectorAll('option')).find((option) => option.value === code);
      return source ? [source.cloneNode(true)] : [];
    });
    if (!options.length) return;

    if (language instanceof HTMLSelectElement) {
      language.replaceChildren(...options);
      language.value = codes.includes(previous) ? previous : codes[0];
    } else {
      language.value = codes.includes(previous) ? previous : codes[0];
    }

    if (status) status.textContent = status.dataset.message || '';
  }
}

if (!customElements.get('kunnie-localization')) customElements.define('kunnie-localization', KunnieLocalization);

/**
 * @typedef {object} DropdownRefs
 * @property {HTMLDetailsElement} disclosure
 * @property {HTMLElement} button
 * @extends {Component<DropdownRefs>}
 */
class KunnieLocalizationDropdown extends Component {
  #listeners;

  toggle() {
    this.#listeners?.abort();
    if (!this.refs.disclosure.open) return;
    this.#listeners = new AbortController();
    const { signal } = this.#listeners;
    document.addEventListener('click', (event) => {
      if (event.target instanceof Node && !this.contains(event.target)) this.refs.disclosure.open = false;
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      this.refs.disclosure.open = false;
      this.refs.button.focus();
    }, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#listeners?.abort();
  }
}

if (!customElements.get('kunnie-localization-dropdown')) {
  customElements.define('kunnie-localization-dropdown', KunnieLocalizationDropdown);
}
